import { render, staticRenderFns } from "./WebServicePushList.vue?vue&type=template&id=0252657b"
import script from "./WebServicePushList.vue?vue&type=script&lang=js"
export * from "./WebServicePushList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports